document.addEventListener('DOMContentLoaded', function () {
    class CustomSlider extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.slideWidth = 0;
        this.slidesPerView = 1;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.slideGap = 15;
      }

      connectedCallback() {
        this.sliderId = this.dataset.id;
        const enabled = this.dataset.enabled === 'true';
        this.container = this.querySelector(`.custom-slider-${this.sliderId}`);
        this.slides = this.querySelectorAll(`.all-${this.sliderId}`);
        this.dotsContainer = this.querySelector(`.slider-dots-${this.sliderId}`);
        this.dots = this.dotsContainer ? this.querySelectorAll(`.slider-dots--${this.sliderId}`) : [];

        if (enabled && window.innerWidth <= 749 && this.slides.length > 0) {
          this.initSlider();
          window.addEventListener('resize', this.onResize.bind(this));
        }
      }

      initSlider() {
        this.calculateSlideWidth();
        if (this.dots.length > 0) {
          this.setupDots();
        }
        this.setupTouchEvents();
      }

      calculateSlideWidth() {
        if (this.slides.length > 0 && this.container) {
          const containerWidth = this.container.offsetWidth;
          const totalGap = this.slideGap * (this.slidesPerView - 1);
          this.slideWidth = (containerWidth - totalGap) / this.slidesPerView;

          this.slides.forEach((slide, index) => {
            slide.style.width = `${this.slideWidth}px`;
            slide.style.flexShrink = '0';
            slide.style.marginRight = (index !== this.slides.length - 1) ? `${this.slideGap}px` : '0';
          });

          this.container.style.display = 'flex';
        }
      }

      setupDots() {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.goToSlide(index);
          });
        });
      }

      setupTouchEvents() {
        this.container.addEventListener('touchstart', (e) => {
          this.touchStartX = e.touches[0].clientX;
        });

        this.container.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].clientX;
          this.handleSwipe();
        });
      }

      handleSwipe() {
        const diff = this.touchStartX - this.touchEndX;
        const threshold = 50;

        if (diff > threshold) {
          this.nextSlide();
        } else if (diff < -threshold) {
          this.prevSlide();
        }
      }

      nextSlide() {
        if (this.currentIndex < this.maxIndex()) {
          this.goToSlide(this.currentIndex + 1);
        }
      }

      prevSlide() {
        if (this.currentIndex > 0) {
          this.goToSlide(this.currentIndex - 1);
        }
      }

      maxIndex() {
        return Math.max(0, this.slides.length - this.slidesPerView);
      }

      goToSlide(index) {
        const maxIndex = this.maxIndex();
        this.currentIndex = Math.max(0, Math.min(index, maxIndex));

        const gapOffset = this.slideGap * this.currentIndex;
        const translateX = (this.slideWidth * this.currentIndex) + gapOffset;

        this.container.style.transition = 'transform 0.3s ease';
        this.container.style.transform = `translateX(-${translateX}px)`;

        if (this.dots.length > 0) {
          this.updateDots();
        }
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === this.currentIndex);
        });
      }

      onResize() {
        if (window.innerWidth <= 749 && this.slides.length > 0) {
          this.calculateSlideWidth();
          this.goToSlide(Math.min(this.currentIndex, this.maxIndex()));
        } else if (this.container) {
          this.container.style.transition = 'none';
          this.container.style.transform = 'translateX(0)';
          this.slides.forEach(slide => {
            slide.style.width = '';
            slide.style.marginRight = '';
            slide.style.flexShrink = '';
          });
          this.container.style.display = '';
        }
      }
    }

    if (!customElements.get('custom-slider')) {
      customElements.define('custom-slider', CustomSlider);
    }
  });